import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
} from "@angular/core";
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { merge, Subscription, empty, Subject, EMPTY } from "rxjs";
import {
	filter,
	map,
	startWith,
	tap,
	switchMap,
	catchError,
	auditTime,
} from "rxjs/operators";
// TODO
// import { FormUtils } from "src/app/utils/form-utils";
import { InfoAnagrafichePFDTO } from "../../models/info-anagrafiche-pf";
import { ComponentOutputStatus } from "../../normalizzazione/component-output-status";
import { CodiceFiscaleService } from "../../services/codice-fiscale/codice-fiscale.service";
import { DelegheService } from "../../services/deleghe-services/deleghe.service";
import { MessageService } from "../../services/message.service";
import { ValidationService } from "../../services/validation.service";

@Component({
	selector: "lib-info-pf",
	templateUrl: "./info-pf.component.html",
	styleUrls: ["./info-pf.component.css"],
})
export class InfoPfComponent implements OnInit, OnDestroy {

	@Input()
	infopf: InfoAnagrafichePFDTO;

	@Input()
	namespace: string;

	@Input()
	cfDifferentFrom: string;

	@Input()
	readOnly: boolean = false;

	@Input()
	resetForm: Subject<boolean>;

	@Input()
	validatorFormControl: boolean = false;

	@Output()
	done: EventEmitter<
		ComponentOutputStatus<InfoAnagrafichePFDTO>
	> = new EventEmitter<ComponentOutputStatus<InfoAnagrafichePFDTO>>();

	form: FormGroup;
	pfSub: Subscription;
	validationSub: Subscription;
	subscription: Subscription;

	codiceRegione: string = "";


	constructor(
		private msg: MessageService,
		private validationService: ValidationService,
		private cfService: CodiceFiscaleService,
		private delegheService: DelegheService
	) { }

	ngOnInit() {

		// console.log('[InfoAnagrafichePFDTO]', this.infopf);

		this.form = new FormGroup({});

		if (this.resetForm) {
			this.subscription = this.resetForm.subscribe(val =>
				val ? this.pulisciForm() : "");
		}

		if (!this.infopf) {
			this.initInfoPf();
		}

		const cfValidators = [
			Validators.required,
			ValidationService.pattern(
				ValidationService.codiceFiscale,
				"cfInvalidoFormalmente"
			),
		];

		if (this.cfDifferentFrom != null) {
			cfValidators.push(
				ValidationService.NotEquals(
					this.cfDifferentFrom,
					"cfDifferentRichiedente"
				)
			);
		}

		const codiceFiscale = new FormControl(
			{ value: this.infopf.codFiscale, disabled: false },
			// cfValidators
			// this.validatorFormControl ? cfValidators: Validators.nullValidator,
			[
				this.validatorFormControl ? Validators.required : Validators.nullValidator,
				ValidationService.pattern(
					ValidationService.codiceFiscale,
					"cfInvalidoFormalmente"
				),
			]
			//TODO
			// [this.validationService.userValidator(TipiPersona.PERSONA_FISICA)]
		);

		this.form.addControl("codiceFiscale", codiceFiscale);

		const nome = new FormControl({ value: this.infopf.nome, disabled: false },
			[
				// Validators.required,
				//	ValidationService.ValidateName,
				this.validatorFormControl ? Validators.required : Validators.nullValidator,
				ValidationService.pattern(ValidationService.formatoName, "formatoName")
			]);
		this.form.addControl("nome", nome);

		const cognome = new FormControl(
			{ value: this.infopf.cognome, disabled: false },
			[
				//Validators.required,
				//ValidationService.ValidateName
				this.validatorFormControl ? Validators.required : Validators.nullValidator,
				ValidationService.pattern(ValidationService.formatoName, "formatoName")
			]);
		this.form.addControl("cognome", cognome);

		// TODO
		// this.validationSub = codiceFiscale.valueChanges.pipe(
		// 	filter(val => val.length == 16),
		// 	auditTime(500)
		// )
		// 	.pipe(
		// 		tap((_) => {
		// 			if (codiceFiscale.errors) {
		// 				delete codiceFiscale.errors["invalidCF"];
		// 			}
		// 		}),
		// 		filter((cf) => codiceFiscale.valid),
		// 		switchMap((cf) =>
		// 			//TODO
		// 			// this.cfService
		// 			// 	.validaCodiceFiscale$(cf, "F")
		// 			// 	.pipe(catchError((err) => empty()))
		// 			this.delegheService.getPersonaFiscaleCodiceFiscale(cf)
		// 				.pipe(
		// 					//TODO
		// 					// catchError((err) => empty())
		// 					catchError(err => {
		// 						codiceFiscale.setErrors({ invalidCF: true });
		// 						return EMPTY;
		// 					})
		// 				)
		// 		),
		// 		tap((validationResult) => {
		// 			console.log('[validationResult]', validationResult);
		// 			// if (!validationResult.valid) {
		// 			if (validationResult == null) {
		// 				codiceFiscale.setErrors({ invalidCF: true });
		// 			} else {
		// 				if (validationResult.residenza != undefined) {
		// 					this.codiceRegione = validationResult?.residenza?.regione?.sigla;
		// 				}
		// 			}
		// 			this.form.updateValueAndValidity();
		// 		})
		// 	)
		// 	.subscribe();

		const changes$ = this.form.valueChanges.pipe(
			map((_) => {
				this.removeSpace(this.form.controls["codiceFiscale"].value);
				const pf = new InfoAnagrafichePFDTO();
				pf.codFiscale = this.form.controls["codiceFiscale"].value;
				pf.nome = this.form.controls["nome"].value;
				pf.cognome = this.form.controls["cognome"].value;
				pf.codiceRegione = this.codiceRegione;
				return pf;
			}),
			startWith(this.infopf),
			map((pf) => {
				// console.log(
				// 	"pf form valid",
				// 	FormUtils.getFormValidationErrors(this.form)
				// );

				const status = ComponentOutputStatus.of(
					!this.form.invalid || this.readOnly == true,
					pf
				);
				// console.log("status", status);
				return status;
			})
		);

		this.pfSub = changes$.subscribe((_) => this.done.emit(_));

		if (this.readOnly) {
			this.form.disable();
		}
	}
	removeSpace(value: string) {
		var reWhiteSpace = /\s/g;
		if (reWhiteSpace.test(value)) {
			this.form.get('codiceFiscale').setValue(value.replace(reWhiteSpace, '')); 
		}
	}

	ngOnDestroy(): void {
		if (this.pfSub) {
			this.pfSub.unsubscribe();
		}

		if (this.validationSub) {
			this.validationSub.unsubscribe();
		}

		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	initInfoPf() {
		const infoPfNew = new InfoAnagrafichePFDTO();
		//TODO
		// if (this.userDetail) {
		// 	infoPfNew.codFiscale = this.userDetail["fiscalNumber"];
		// 	infoPfNew.cognome = this.userDetail["familyName"];
		// 	infoPfNew.nome = this.userDetail["name"];
		// }
		this.infopf = infoPfNew;
	}

	pulisciForm() {
		const keys = Object.keys(this.form.value);
		keys.forEach(key => {
			const control: AbstractControl = this.form.get(key);
			control.setValue("");
		});
	}

	public _resetForm() {
		this.form?.reset();
	}
}